import { Routes } from '@angular/router';
import { LoginViewComponent } from '../view/login-view/login-view.component';
import { isAuthenticatedCanActivateFn } from './oauth2/route-can-activate';
import { LoginRedirectViewComponent } from '../view/login-redirect-view/login-redirect-view.component';

export enum ROUTE_PATH {
    ENERGY_SUPPLY = 'energy_supply',
    ENERGY_SUPPLY_GENERATION = 'generation',
    ENERGY_SUPPLY_SUPPLY = 'supply',
    ENERGY_SUPPLY_AVAILABILITY = 'availability',
    ENERGY_SUPPLY_FINANCIAL = 'financial',
    ENERGY_SUPPLY_DEMAND = 'demand',
    ENERGY_SUPPLY_PORTFOLIO = 'portfolio',
    PROFILE = 'profile',
    DASHBOARD = 'dashboard',
}

export const ROUTE_PATH_LIST: ROUTE_PATH[] = Object.values(ROUTE_PATH);
export const routes: Routes = [
    {
        path: '',
        loadComponent: () => import('../view/main/main-view/main-view.component').then((m) => m.MainViewComponent),
        loadChildren: () => import('../config/main-routes.config').then((m) => m.mainRoutes),
        canActivateChild: [isAuthenticatedCanActivateFn],
    },
    {
        path: 'auth/login', component: LoginViewComponent,
    },
    {
        path: 'auth/login-redirect', component: LoginRedirectViewComponent,
    },
];

